import React from "react";
import styles from "./Stats.module.scss";
import { DataPointCard } from "../../../molecules/DataPointCard";
import { FilterToolbar } from "../../../molecules/FilterToolbar";
import { Page } from "../../../layouts/Page";
import SelectedFilter from "../../../molecules/FilterToolbar/SelectedFilter";

function Stats({
  totalVideos,
  totalViews,
  totalSales,
  totalSalesAmount,
  filters,
  filterOptions,
  setFilters
}) {
  return (
    <>
      {Object.keys(filters).map((filterKey) => {
        const matchingSelection = filters[filterKey];
        const matchingFilter = filterOptions.find((f) => f.key === filterKey);

        if (!matchingFilter) {
          throw new Error(`Invalid filter selected: ${filterKey}`);
        }

        return (
          <div className={styles.filterHolder}>
            <SelectedFilter
              key={filterKey}
              selection={matchingSelection}
              filter={matchingFilter}
              value={filters}
              onChange={setFilters}
            />
          </div>
        );
      })}
      <div className={styles.dataPointCardsContainer}>
        <div className={styles.row}>
          <div className={styles.colQuarter}>
            <div className={styles.dataStats}>
              <DataPointCard
                color="#09A496"
                iconName="grouped-bar-chart"
                title="TOTAL # OF VIDEOS"
                value={totalVideos || 0}
              />
            </div>
          </div>
          <div className={styles.colQuarter}>
            <div className={styles.dataStats}>
              <DataPointCard
                color="#FF5D78"
                iconName="eye-open"
                title="TOTAL # OF VIEWS"
                value={totalViews || 0}
              />
            </div>
          </div>
          <div className={styles.colQuarter}>
            <div className={styles.dataStats}>
              <DataPointCard
                color="#09A496"
                iconName="timeline-line-chart"
                title="TOTAL # OF SALES"
                value={totalSales || 0}
              />
            </div>
          </div>
          <div className={styles.colQuarter}>
            <div className={styles.dataStats}>
              <DataPointCard
                color="#FF5D78"
                iconName="Cash"
                title="TOTAL IN SALES ($)"
                value={totalSalesAmount || 0}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Stats;
